module.exports = __webpack_public_path__ + "img/129.2200ac98.jpg";